// extracted by mini-css-extract-plugin
module.exports = {"contained":"button_contained__HxLDS","text":"button_text__fwkMT","outlined":"button_outlined__xkZYT","loading":"button_loading__YdErf"};